import { Injectable } from '@angular/core';
import { AuthService } from '../../../@core/auth/auth.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { DownloadItems } from '../models/download-items';

@Injectable({
  providedIn: 'root'
})
export class DownloadsService {
  protected basePath = '/';
  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getDownloadItems(includeInactive: boolean = false): Observable<DownloadItems[]> {

    let queryParameters = new HttpParams();

    queryParameters.append('includeInactive', includeInactive.toString());

    return this.httpClient.get<DownloadItems[]>(`${this.basePath}/api/downloadItems`);
  }

  downloadFileBlob(testdownloadData: DownloadItems): Observable<Blob> {
    const fileUrl = testdownloadData.fileUrl;
    return this.httpClient.get(fileUrl, { responseType: 'blob' });
  }
}
